// TaskRemarkModal — small popup to add / edit a task's remark (portaled to body).

import React, { useState } from "react";
import { createPortal } from "react-dom";
import { X, MessageSquare } from "lucide-react";
import "../../css/tasks/taskdetail.css";

export default function TaskRemarkModal({ initialValue = "", onClose, onSave, saving }) {
  const [value, setValue] = useState(initialValue || "");

  return createPortal(
    <div className="td-overlay" onClick={onClose}>
      <div className="td-modal td-modal-sm" onClick={(e) => e.stopPropagation()}>
        <div className="td-header">
          <h3 className="td-title">
            <MessageSquare size={16} style={{ marginRight: 6, verticalAlign: "-2px" }} />
            {initialValue ? "Edit Remark" : "Add Remark"}
          </h3>
          <button className="td-close" type="button" onClick={onClose}>
            <X size={18} />
          </button>
        </div>

        <div className="td-body">
          <textarea
            className="tr-textarea"
            rows={4}
            autoFocus
            placeholder="Type your remark about this task..."
            value={value}
            onChange={(e) => setValue(e.target.value)}
          />
          <div className="tr-actions">
            <button className="tr-btn-cancel" type="button" onClick={onClose} disabled={saving}>
              Cancel
            </button>
            <button
              className="tr-btn-save"
              type="button"
              onClick={() => onSave(value.trim())}
              disabled={saving}
            >
              {saving ? "Saving..." : "Save Remark"}
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
}
